export interface DigitalWalletOptions {
  isGooglePay?: boolean;
  isApplePay?: boolean;
  token?: string;
  bankPaymentStorageKey?: string;
}
